import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigPortas } from '../../../models/configportas.model';
import { AbConfigPortas } from 'app/abstract/full-pages/config-portas/config-portas.abstract';



@Injectable({ providedIn: 'root' })
export class ConfigPortasService extends AbConfigPortas {
  prefixo: string = "config_portas";

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigPortas(): Observable<any> {
    return this.get(`${this.prefixo}/1`);
  }

  public getConfigPortasHub(): Observable<any> {
    return this.get(`${this.prefixo}/hub/1`);
  }

  public getConfigPortasPromise() {
    return this.get(`${this.prefixo}/1`).toPromise().catch();
  }

  public carregarPortas(configPortas: ConfigPortas): Observable<any> {
    return this.http.post(`${this.url}${this.prefixo}/carregar_portas`, configPortas);
  }

  public saveConfigPortas(configPortas: ConfigPortas): Observable<any> {
    return this.save(`${this.prefixo}/`, configPortas);
  }
}